/**
 * Composable for tracking viewport dimensions
 * SSR-safe: uses sensible defaults, updates to actual values after hydration
 */
export const useViewportSize = () => {
	// Use sensible SSR-safe defaults (desktop-like viewport)
	// This ensures server and client render the same HTML initially
	const width = ref(1024);
	const height = ref(768);

	const updateSize = () => {
		if (import.meta.client) {
			width.value = window.innerWidth;
			height.value = window.innerHeight;
		}
	};

	onMounted(() => {
		updateSize();
		window.addEventListener('resize', updateSize);
	});

	onUnmounted(() => {
		if (import.meta.client) {
			window.removeEventListener('resize', updateSize);
		}
	});

	// REMOVED: Immediate client check that caused hydration mismatch
	// The values will be updated in onMounted after hydration

	return {
		width: readonly(width),
		height: readonly(height),
	};
};
